var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"app_layout"},[_c('a-layout-header',{class:_vm.$route.fullPath == '/PartyArticleListPage'?'partyArticleListPage':''},[_c('Navigation',{staticClass:"container"})],1),_c('a-layout-content',[_c('router-view')],1),_c('a-layout-footer',{staticClass:"contact_page"},[_c('Contact'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }